module.exports = __webpack_public_path__ + "img/icon-ring.e4926201.svg";